import * as React from "react"

export const Layout = ({ children }: Layout.Props) => {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto min-h-dvh flex flex-col">
      <main className="relative flex-1 size-full flex flex-col z-10 ">{children}</main>
    </div>
  )
}

export namespace Layout {
  export type Props = {
    children: React.ReactNode
  }
}
